import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import { useAnalyticsData } from '../../../hooks';

const CostAnalytics: React.FC = () => {
  const { data, loading, error } = useAnalyticsData();

  if (loading) {
    return (
      <Container>
        <Box textAlign="center" padding="l">
          <Spinner />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box color="text-status-error" textAlign="center" padding="l">
          Error loading cost data
        </Box>
      </Container>
    );
  }

  const costData = data && data.costAnalytics;
  const completeCost = data && data.completeSummary && data.completeSummary.totalCost;

  return (
    <Container
      header={
        <Header variant="h2">
          Cost Analysis
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="m">
        <Box>
          <Box variant="awsui-key-label">Total Processing Cost (All Time)</Box>
          <Box fontSize="heading-xl" fontWeight="bold">
            ${(completeCost || 0).toFixed(2)}
          </Box>
          <Box variant="small" color="text-status-info">
            Complete historical data
          </Box>
        </Box>

        <SpaceBetween direction="vertical" size="xs">
          <Box>
            <Box variant="small">Period Cost ({(costData && costData.period) || 'N/A'})</Box>
            <Box fontWeight="bold">${((costData && costData.totalCost) || 0).toFixed(2)}</Box>
          </Box>
          <Box>
            <Box variant="small">Cost per Minute</Box>
            <Box fontWeight="bold">${((costData && costData.costPerMinute) || 0.024).toFixed(3)}</Box>
          </Box>
          
          <Box>
            <Box variant="small">Cost Savings vs Manual</Box>
            <Box fontWeight="bold" color="text-status-success">
              ${((costData && costData.costSavings) || 0).toFixed(2)}
            </Box>
          </Box>
        </SpaceBetween>

        <Box variant="small" color="text-status-info">
          * Savings calculated assuming $1.00/minute for manual transcription
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default CostAnalytics;
